// extracted by mini-css-extract-plugin
export default {"searchBox":"ChatSearch_searchBox__Agiyq","chatInput":"ChatSearch_chatInput__y4+5S","inputIcon":"ChatSearch_inputIcon__+T3qB"};